import { Outlet } from 'react-router-dom'
import ImpersonationBanner from '@/components/admin/ImpersonationBanner'
import AppSidebar from './AppSidebar'

export default function DashboardLayout() {
  return (
    <div className="min-h-screen bg-warm-50 flex flex-col">
      {/* Impersonation Banner (shows when employee is impersonating a tenant) */}
      <ImpersonationBanner />

      <div className="flex-1 flex">
        {/* Sidebar */}
        <AppSidebar />

        {/* Main content */}
        <div className="flex-1 flex flex-col min-w-0">
          {/* Page content */}
          <main className="flex-1 p-8 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  )
}
